exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._3J12-qKmZPV5CmHHLQMcOR{border:1px solid;border-radius:100%;padding:2px}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/SPRINTA/v2/atoms/FontIcon/additionals.css"],"names":[],"mappings":"AAAA,yBACI,iBAAkB,AAClB,mBAAoB,AACpB,WAAa,CAChB","file":"additionals.css","sourcesContent":[".circle {\n    border: 1px solid;\n    border-radius: 100%;\n    padding: 2px;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"circle": "_3J12-qKmZPV5CmHHLQMcOR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/SPRINTA/v2/atoms/FontIcon/additionals.css
// module id = 967
// module chunks = 0 1 2 3